'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _react = require('react');

var _reactRedux = require('react-redux');

var _user = require('../../redux/modules/user');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoastaGlobalSetter = (_dec = (0, _reactRedux.connect)(function (state) {
    var userData = (0, _user.getUserData)(state) || {};
    return (0, _extends3.default)({
        ANMS: 0,
        bidderId: 0
    }, userData);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(SoastaGlobalSetter, _Component);

    function SoastaGlobalSetter() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SoastaGlobalSetter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SoastaGlobalSetter.__proto__ || (0, _getPrototypeOf2.default)(SoastaGlobalSetter)).call.apply(_ref, [this].concat(args))), _this), _this.setSoasta = function (props) {
            if (typeof window !== 'undefined') {
                // SSR doesn't use window
                var ANMS = props.ANMS,
                    bidderId = props.bidderId;

                var highANMS = ANMS > 4500 ? 1 : 0;
                (0, _set3.default)(window, 'soasta.user', { ANMS: ANMS, bidderId: bidderId, highANMS: highANMS });
                (0, _set3.default)(window, 'BOOMR.xhr_excludes', {
                    'api.sail-track.com': true,
                    'api.segment.com': true,
                    'c.go-mpulse.net': true,
                    'c.riskified.com': true,
                    'doubleclick.net': true,
                    'r.fullstory.com': true,
                    'sumo.com': true,
                    'www.youtube.com': true
                });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SoastaGlobalSetter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setSoasta(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setSoasta(nextProps);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['ANMS', 'bidderId']);
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return SoastaGlobalSetter;
}(_react.Component)) || _class);
exports.default = SoastaGlobalSetter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Soasta/SoastaGlobalSetter.js
// module id = mZDp
// module chunks = 57